import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';

const STEPS = ['بيانات الشركة', 'المستندات', 'بيانات الدخول', 'المراجعة'];

export default function RegisterCompany() {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    company_name:'', email:'', phone:'', address:'', national_id:''
  });
  const [password, setPassword] = useState('');
  const [adminName, setAdminName] = useState('');
  const [commercialFiles, setCommercialFiles] = useState([]);
  const [taxFiles, setTaxFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadedDocs, setUploadedDocs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handle = e => setForm({...form, [e.target.name]: e.target.value});

  const uploadDocs = async () => {
    if (!commercialFiles.length) return setError('يرجى رفع السجل التجاري');
    if (!taxFiles.length) return setError('يرجى رفع البطاقة الضريبية');
    setUploading(true); setError('');
    try {
      const data = new FormData();
      commercialFiles.forEach(f => data.append('commercial_register', f));
      taxFiles.forEach(f => data.append('tax_card', f));
      const r = await axios.post(`${API_BASE}/uploads/company-docs`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setUploadedDocs(r.data.files);
      setStep(2);
    } catch(err) {
      setError(err.response?.data?.error || 'فشل رفع الملفات');
    } finally { setUploading(false); }
  };

  const submit = async () => {
    setLoading(true); setError('');
    try {
      await axios.post(`${API_BASE}/companies/register`, {
        company_name:   form.company_name,
        email:          form.email,
        phone:          form.phone,
        address:        form.address,
        national_id:    form.national_id,
        admin_name:     adminName,
        admin_phone:    form.phone,
        admin_password: password,
        documents:      uploadedDocs,
      });
      setSuccess(true);
    } catch(err) {
      setError(err.response?.data?.error || 'حصل خطأ');
    } finally { setLoading(false); }
  };

  if (success) return (
    <div style={S.page}>
      <div style={S.successCard}>
        <div style={{fontSize:'60px', marginBottom:'16px'}}>🎉</div>
        <h2 style={{color:'#1a1a2e', fontSize:'22px', fontWeight:'900', margin:'0 0 12px'}}>تم التسجيل بنجاح!</h2>
        <p style={{color:'#555', fontSize:'15px', lineHeight:'1.8', margin:'0 0 20px'}}>
          تم استلام طلب انضمام شركتك. سيتم مراجعة بياناتك ومستنداتك من قِبَل الإدارة وسنتواصل معك خلال 24-48 ساعة.
        </p>
        <div style={S.infoBox}>
          <p style={{margin:'0 0 8px', fontWeight:'bold', color:'#1a1a2e'}}>📋 الخطوات القادمة:</p>
          <p style={{margin:'4px 0', color:'#555', fontSize:'14px'}}>1. مراجعة المستندات من الإدارة</p>
          <p style={{margin:'4px 0', color:'#555', fontSize:'14px'}}>2. الموافقة وإرسال رابط الدفع</p>
          <p style={{margin:'4px 0', color:'#555', fontSize:'14px'}}>3. دفع رسوم الاشتراك</p>
          <p style={{margin:'4px 0', color:'#555', fontSize:'14px'}}>4. تفعيل الحساب والدخول ببيانات اخترتها</p>
        </div>
        <a href="/" style={S.homeBtn}>العودة للرئيسية</a>
      </div>
    </div>
  );

  return (
    <div style={S.page}>
      <div style={S.container}>
        <div style={S.header}>
          <div style={{fontSize:'40px', marginBottom:'8px'}}>🏢</div>
          <h1 style={S.title}>انضم لمنصة بسرعة</h1>
          <p style={S.sub}>سجّل شركتك وابدأ في توصيل الطلبات</p>
        </div>

        <div style={S.stepsRow}>
          {STEPS.map((s,i) => (
            <div key={i} style={{display:'flex', alignItems:'center', gap:'6px'}}>
              <div style={{...S.stepCircle, ...(step===i?S.stepActive:step>i?S.stepDone:{})}}>
                {step>i?'✓':i+1}
              </div>
              <span style={{fontSize:'12px', color:step===i?'#0f3460':'#aaa'}}>{s}</span>
              {i<STEPS.length-1 && <div style={S.stepLine}/>}
            </div>
          ))}
        </div>

        <div style={S.card}>
          {step === 0 && (
            <>
              <p style={S.sectionTitle}>📋 بيانات الشركة</p>
              {[
                ['company_name','اسم الشركة','text','شركة النيل للتوصيل',true],
                ['email','البريد الإلكتروني','email','info@company.com',true],
                ['phone','رقم هاتف الشركة (سيُستخدم لتسجيل الدخول)','tel','01xxxxxxxxx',true],
                ['address','العنوان','text','القاهرة، مصر',false],
                ['national_id','رقم السجل التجاري','text','',false],
              ].map(([name,label,type,ph,req]) => (
                <div key={name} style={S.field}>
                  <label style={S.label}>{label}{req&&<span style={{color:'#e74c3c'}}> *</span>}</label>
                  <input style={S.input} name={name} type={type} placeholder={ph}
                    value={form[name]} onChange={handle}/>
                </div>
              ))}
              {error && <p style={S.error}>{error}</p>}
              <button style={S.nextBtn} onClick={() => {
                if (!form.company_name||!form.email||!form.phone) return setError('يرجى ملء الحقول المطلوبة');
                setError(''); setStep(1);
              }}>التالي ←</button>
            </>
          )}

          {step === 1 && (
            <>
              <p style={S.sectionTitle}>📄 المستندات المطلوبة</p>

              <div style={S.uploadBox}>
                <p style={S.uploadLabel}>السجل التجاري <span style={{color:'#e74c3c'}}>*</span></p>
                <p style={{color:'#888', fontSize:'12px', margin:'0 0 10px'}}>يمكن رفع أكثر من صورة (JPG, PNG, PDF)</p>
                <label style={S.uploadBtn}>
                  📎 اختر الصور
                  <input type="file" multiple accept="image/*,.pdf" style={{display:'none'}}
                    onChange={e => setCommercialFiles(Array.from(e.target.files))}/>
                </label>
                {commercialFiles.length > 0 && (
                  <div style={S.fileList}>
                    {commercialFiles.map((f,i) => <span key={i} style={S.fileTag}>✅ {f.name}</span>)}
                  </div>
                )}
              </div>

              <div style={S.uploadBox}>
                <p style={S.uploadLabel}>البطاقة الضريبية <span style={{color:'#e74c3c'}}>*</span></p>
                <p style={{color:'#888', fontSize:'12px', margin:'0 0 10px'}}>يمكن رفع وجهين (JPG, PNG, PDF)</p>
                <label style={S.uploadBtn}>
                  📎 اختر الصور
                  <input type="file" multiple accept="image/*,.pdf" style={{display:'none'}}
                    onChange={e => setTaxFiles(Array.from(e.target.files))}/>
                </label>
                {taxFiles.length > 0 && (
                  <div style={S.fileList}>
                    {taxFiles.map((f,i) => <span key={i} style={S.fileTag}>✅ {f.name}</span>)}
                  </div>
                )}
              </div>

              {error && <p style={S.error}>{error}</p>}
              <div style={{display:'flex', gap:'10px', marginTop:'16px'}}>
                <button style={S.backBtn} onClick={() => setStep(0)}>→ رجوع</button>
                <button style={S.nextBtn} onClick={uploadDocs} disabled={uploading}>
                  {uploading ? '⏳ جاري الرفع...' : 'التالي ←'}
                </button>
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <p style={S.sectionTitle}>🔐 بيانات تسجيل الدخول</p>
              <div style={S.noteBox}>
                <p style={{margin:0, fontSize:'13px', color:'#0f3460'}}>
                  ℹ️ هاتف شركتك (<strong>{form.phone}</strong>) وكلمة المرور دي هيا بيانات دخولك على بوابة الشركة
                </p>
              </div>
              <div style={S.field}>
                <label style={S.label}>اسم المسؤول <span style={{color:'#e74c3c'}}>*</span></label>
                <input style={S.input} type="text" placeholder="الاسم كامل"
                  value={adminName} onChange={e => setAdminName(e.target.value)}/>
              </div>
              <div style={S.field}>
                <label style={S.label}>كلمة المرور <span style={{color:'#e74c3c'}}>*</span></label>
                <input style={S.input} type="password" placeholder="6 أحرف على الأقل"
                  value={password} onChange={e => setPassword(e.target.value)}/>
              </div>
              {error && <p style={S.error}>{error}</p>}
              <div style={{display:'flex', gap:'10px', marginTop:'16px'}}>
                <button style={S.backBtn} onClick={() => setStep(1)}>→ رجوع</button>
                <button style={S.nextBtn} onClick={() => {
                  if (!adminName||!password) return setError('يرجى ملء كل الحقول');
                  if (password.length < 6) return setError('كلمة المرور 6 أحرف على الأقل');
                  setError(''); setStep(3);
                }}>التالي ←</button>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <p style={S.sectionTitle}>✅ مراجعة البيانات</p>
              <div style={S.reviewBox}>
                <p style={S.reviewTitle}>🏢 بيانات الشركة</p>
                {[['الاسم',form.company_name],['الإيميل',form.email],['الهاتف',form.phone],['العنوان',form.address||'—'],['السجل التجاري',form.national_id||'—']].map(([l,v])=>(
                  <div key={l} style={S.reviewRow}><span style={{color:'#888'}}>{l}</span><span style={{fontWeight:'bold'}}>{v}</span></div>
                ))}
                <p style={{...S.reviewTitle, marginTop:'16px'}}>📄 المستندات</p>
                <div style={S.reviewRow}><span style={{color:'#888'}}>السجل التجاري</span><span style={{color:'#27ae60'}}>✅ {commercialFiles.length} ملف</span></div>
                <div style={S.reviewRow}><span style={{color:'#888'}}>البطاقة الضريبية</span><span style={{color:'#27ae60'}}>✅ {taxFiles.length} ملف</span></div>
                <p style={{...S.reviewTitle, marginTop:'16px'}}>🔐 بيانات الدخول</p>
                <div style={S.reviewRow}><span style={{color:'#888'}}>المسؤول</span><span style={{fontWeight:'bold'}}>{adminName}</span></div>
                <div style={S.reviewRow}><span style={{color:'#888'}}>الهاتف</span><span style={{fontWeight:'bold'}}>{form.phone}</span></div>
                <div style={S.reviewRow}><span style={{color:'#888'}}>كلمة المرور</span><span style={{fontWeight:'bold'}}>••••••••</span></div>
              </div>
              <div style={S.noteBox}>
                <p style={{margin:0, fontSize:'13px', color:'#0f3460'}}>
                  بعد إرسال الطلب سيتم مراجعة مستنداتك من الإدارة. عند الموافقة ستصلك رسالة برابط الدفع لتفعيل حسابك.
                </p>
              </div>
              {error && <p style={S.error}>{error}</p>}
              <div style={{display:'flex', gap:'10px', marginTop:'16px'}}>
                <button style={S.backBtn} onClick={() => setStep(2)}>→ رجوع</button>
                <button style={{...S.nextBtn, background:'linear-gradient(135deg,#27ae60,#2ecc71)'}}
                  onClick={submit} disabled={loading}>
                  {loading ? '⏳ جاري الإرسال...' : '✅ إرسال الطلب'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const S = {
  page:        { minHeight:'100vh', background:'#f0f2f5', direction:'rtl', padding:'20px', paddingBottom:'40px' },
  container:   { maxWidth:'580px', margin:'0 auto' },
  header:      { textAlign:'center', marginBottom:'20px', paddingTop:'20px' },
  title:       { fontSize:'26px', fontWeight:'900', color:'#1a1a2e', margin:'0 0 6px' },
  sub:         { color:'#888', fontSize:'14px', margin:0 },
  stepsRow:    { display:'flex', justifyContent:'center', alignItems:'center', gap:'6px', marginBottom:'20px', flexWrap:'wrap' },
  stepCircle:  { width:'30px', height:'30px', borderRadius:'50%', background:'#ddd', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:'bold', color:'#888', flexShrink:0 },
  stepActive:  { background:'#0f3460', color:'#fff' },
  stepDone:    { background:'#27ae60', color:'#fff' },
  stepLine:    { width:'20px', height:'2px', background:'#ddd' },
  card:        { background:'#fff', borderRadius:'16px', padding:'24px', boxShadow:'0 2px 12px rgba(0,0,0,0.08)' },
  sectionTitle:{ fontSize:'15px', fontWeight:'bold', color:'#1a1a2e', margin:'0 0 16px' },
  field:       { marginBottom:'14px' },
  label:       { display:'block', fontSize:'13px', color:'#555', marginBottom:'5px', fontWeight:'bold' },
  input:       { width:'100%', padding:'12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', boxSizing:'border-box', direction:'rtl', outline:'none' },
  nextBtn:     { flex:2, padding:'13px', background:'linear-gradient(135deg,#0f3460,#e94560)', color:'#fff', border:'none', borderRadius:'10px', fontSize:'15px', fontWeight:'bold', cursor:'pointer' },
  backBtn:     { flex:1, padding:'13px', background:'#f5f5f5', border:'none', borderRadius:'10px', fontSize:'15px', cursor:'pointer', color:'#555' },
  error:       { color:'#e74c3c', fontSize:'13px', marginTop:'8px', textAlign:'center' },
  uploadBox:   { background:'#f8f9ff', borderRadius:'12px', padding:'16px', marginBottom:'16px', border:'1px dashed #c7d2fe' },
  uploadLabel: { fontWeight:'bold', color:'#1a1a2e', margin:'0 0 4px', fontSize:'14px' },
  uploadBtn:   { display:'inline-block', padding:'10px 20px', background:'#0f3460', color:'#fff', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:'bold' },
  fileList:    { marginTop:'10px', display:'flex', flexWrap:'wrap', gap:'6px' },
  fileTag:     { background:'#e8f5e9', color:'#27ae60', padding:'4px 10px', borderRadius:'20px', fontSize:'12px' },
  noteBox:     { background:'#f0f4ff', borderRadius:'8px', padding:'12px', margin:'12px 0' },
  reviewBox:   { background:'#f8f9ff', borderRadius:'12px', padding:'16px', marginBottom:'12px' },
  reviewTitle: { fontWeight:'bold', color:'#0f3460', margin:'0 0 10px', fontSize:'14px' },
  reviewRow:   { display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid #eee', fontSize:'13px' },
  successCard: { maxWidth:'480px', margin:'40px auto', background:'#fff', borderRadius:'20px', padding:'40px', textAlign:'center', boxShadow:'0 4px 20px rgba(0,0,0,0.1)' },
  infoBox:     { background:'#f8f9ff', borderRadius:'12px', padding:'16px', marginBottom:'20px', textAlign:'right' },
  homeBtn:     { display:'inline-block', padding:'12px 30px', background:'linear-gradient(135deg,#0f3460,#e94560)', color:'#fff', borderRadius:'10px', textDecoration:'none', fontWeight:'bold', fontSize:'15px' },
};
